export default __webpack_public_path__ + "static/media/large-crumb1-pause.46cebeac.png";